import reportsReducer from './modules/report/common/redux/reducers/ReportsReducer';
import reportDownlaodReducer from './modules/report/common/redux/reducers/ReportDownloadReducer';
import reportCustomFilterReducer from './modules/report/common/redux/reducers/ReportCustomFilterReducer';
import periodSelectionReducer from './modules/wizard/period-selector/redux/reducers/PeriodSelectionReducer';
import postalOperatorSelectorReducers from './modules/wizard/target-node-impc-selector/redux/reducers/index';
import mrdPostalOperatorSelectorReducers from './modules/wizard/target-node-mrd-impc-selector/redux/reducers/index';
import carrierSelectorReducers from './modules/wizard/target-node-carrier-selector/redux/reducers/index';
import handlerSelectorReducers from './modules/wizard/target-node-handler-selector/redux/reducers/index';
import reportsSelectorReducers from './modules/wizard/target-node-report-selector/redux/reducers/index';
import operatorUserReducer from './modules/wizard/target-node-operator-user-selector/redux/reducers/index';
import itemCriteriaReducer from './modules/wizard/target-node-item-criteria-selector/redux/reducers/index';
import postalOperatorMailboxSelectorReducers from './modules/wizard/target-node-mailbox-selector/redux/reducers/index';
import postalOperatorUnlocodeSelectorReducers from './modules/wizard/target-node-unlocode-selector/redux/reducers/index';
import productSelectorReducer from './modules/wizard/product-selector/redux/reducers/index';
import transportModeReducer from './modules/wizard/transport-mode-selector/redux/reducers/index';
import capeNotificationReducer from './modules/common/redux/reducers/CapeNotificationReducer';
import userReportReducer from './modules/user/redux/reducers/UserReportReducer';
import dashboardReducer from './modules/dashboard/redux/reducers/DashboardReducer';
import selectionCriteriaWizardReducer from './modules/wizard/common/redux/reducer/SelectionCriteriaWizardReducer';
import adminDataReducer from './modules/admin/dashboard/redux/reducers/AdminDashboardReducer';

export default {
  postalOperatorSelector: postalOperatorSelectorReducers,
  mrdPostalOperatorSelector: mrdPostalOperatorSelectorReducers,
  carrierSelector: carrierSelectorReducers,
  handlerSelector: handlerSelectorReducers,
  reportsSelector: reportsSelectorReducers,
  operatorUserSelector: operatorUserReducer,
  itemCriteriaSelector: itemCriteriaReducer,
  postalOperatorMailboxSelector: postalOperatorMailboxSelectorReducers,
  postalOperatorUnlocodeSelector: postalOperatorUnlocodeSelectorReducers,
  reporting: reportsReducer,
  periodSelector: periodSelectionReducer,
  productSelector: productSelectorReducer,
  transportModeSelector: transportModeReducer,
  notification: capeNotificationReducer,
  userData: userReportReducer,
  dashboard: dashboardReducer,
  selectionCriteriaWizard: selectionCriteriaWizardReducer,
  downloadReportResult: reportDownlaodReducer,
  reportCustomFilter: reportCustomFilterReducer,
  adminData: adminDataReducer,
};
